import StringUtils from "./stringutil";
function Drawer(canvasId)
{
    let canvas1 = document.getElementById(canvasId);
    this.ctx =canvas1.getContext('2d');
    this.draw=function(drawList,callback)
    {
       
        this.drawItem(0,drawList,callback);
    }
    this.drawItem=function(index,drawList,callback)
    {
        if(index>=drawList.length)
        {
           
            callback(true);
        }
        else
        {
            let it=drawList[index];
            if(it.type=="img")
            {
                drawImage(this.ctx,it,(ok,res)=>{
                   /* if(ok)
                        this.drawItem(index+1,drawList,callback);
                    else
                        callback(false,res);*/
                    console.log(ok,res);
                        this.drawItem(index+1,drawList,callback);
                });
            }
            else if(it.type=='text')
            {
                drawText(this.ctx,it);
                this.drawItem(index+1,drawList,callback);
            }
        }
    }
    
    this.save=function()
    {
       
    }
    this.textWidth=(txt,fontSize,font)=>{
        this.ctx.save();
        font=fontSize+"px "+(font||"");
       
        this.ctx.font=font;
        var w1 = this.ctx.measureText(txt).width;
        this.ctx.restore();
        return w1;
    }
}
function loadImage(info,callback)
{
    //callback(true,{path:new Image(info.url)});
    if(info.imgInfo!=null)
    {
        callback(true,info.imgInfo);
        return;
    }
    let img=new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload=()=>{
      
        callback(true,{path:img});
    };
    img.onerror=()=>{
          callback(false,{err:"图片加载失败"});
    }
    img.src=info.url;
    
}
function drawImage(ctx,info,callback)
{
  
    loadImage(info,(ok,res)=>{
      //  console.log(ok,res);
        if(!ok)
        {
            if(callback)
                callback(false,res);
            return;
        }
        ctx.save();
        if(info.circle)
        {
            ctx.beginPath();
            ctx.arc(info.x+info.width/2, info.y+info.height/2, info.width/2, 0, Math.PI * 2, false);
            ctx.clip();  
        }
        else if(info.radius>0)
        {
            let x=info.x;
            let y=info.y;
            let r=info.radius;
            ctx.beginPath(); 
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + info.width, y, x + info.width, y + r, r); 
            ctx.arcTo(x + info.width, y + info.height, x + info.width - r, y + info.height, r); 
            ctx.arcTo(x, y + info.height, x, y + info.height - r, r); 
            ctx.arcTo(x, y, x + r, y, r);
            ctx.clip();
        }
        if(info.srcWidth)
            ctx.drawImage(res.path,info.srcX,info.srcY,info.srcWidth,info.srcHeight,info.x,info.y,info.width,info.height);
        else
         ctx.drawImage(res.path,info.x,info.y,info.width,info.height);
        ctx.restore();
        if(callback)
            callback(true);

   
    });
}
function drawText(ctx,info)
{
    ctx.save();
    let fontSize=info.fontSize||20;
    let lineHeight=info.lineHeight||(fontSize*1.2);
    let maxWidth=info.maxWidth||750;
    let textAlign=info.textAlign||'left';
    let font=fontSize+"px "+(info.font||"");
    console.log(font)
    ctx.textAlign=textAlign;
    ctx.font=font;
    if(info.color)
        ctx.fillStyle=(info.color);
    let lines =splitText(ctx, info.text, lineHeight,maxWidth);
    for (let i = 0; i < lines.length; i++)
    {
        if(info.singleLine)
        {
            if(lines.length>1)
                ctx.fillText(lines[i]+"...", info.x, fontSize  + info.y + i * lineHeight);
            else 
             ctx.fillText(lines[i], info.x, fontSize  + info.y + i * lineHeight);
            break;
        }
        else
         ctx.fillText(lines[i], info.x, fontSize  + info.y + i * lineHeight);
    }
    ctx.restore();

}


function splitText(ctx, text,  lineHeight, maxWidth)
{
    var strArray = StringUtils.toArray(text);
      var w = 0;
      var str = null;
      var mw = 0;
     
      var pmw = maxWidth;
      var lines=[];
      for (var i = 0; i < strArray.length; i++) {
        var w1 = ctx.measureText(strArray[i]).width;
        if (w + w1 <= pmw) {
          w += w1;
          if (str == null)
            str = "";
          str += strArray[i];
        }
        else {
          lines.push(str);
          str = strArray[i];
          if (w > mw)
            mw = w;
          w = w1;
         
        }

      }
      if (str != null) {
        lines.push(str);
        if (w > mw)
          mw = w;
      
      }
     return lines;
}
export default{
    Drawer:Drawer
}


// WEBPACK FOOTER //
// ./src/js/canvasutils.js